<script setup lang="ts">
/**
 * Højre handlings-drawer ([D-334], 28-09-2026): tredje push-panel i skallen,
 * ved siden af filter-draweren og sidens indstillinger. Åbnes af en sides
 * handlingsknap i headeren (fx "Tilpas varenumre" på Lagervarer) og viser de
 * handlinger der kan udføres på det man har markeret.
 *
 * Markuppen er FilterDrawers 1:1 (drawer-konventionen): 300 px på sidens
 * baggrund, 1 px skille-linje på venstre kant, h-14-header med titel og luk-X,
 * indhold px-4 pb-4 uden synlig scrollbar (§45), sektioner via
 * FilterDrawerSection. Titel og indhold leveres af siden via
 * <ActionDrawerContent>; gensidigt udelukkende med de 2 andre drawere
 * (useActionDrawer i useDrawer.ts).
 *
 * bg-page + z-40: en tabel der ikke kan krympe til sin kolonne, må aldrig
 * tegnes oven på panelet (Charlie 28-09-2026, samme rettelse på de 2 andre).
 */

import { useActionDrawer } from '../composables/useDrawer';
import { ICONS } from '../icons';

const { isOpen, title, close } = useActionDrawer();
</script>

<template>
  <aside
    class="sticky top-0 h-screen overflow-hidden transition-[width] duration-200 ease-out shrink-0 relative z-40 bg-page print:hidden"
    :class="isOpen ? 'w-[300px]' : 'w-0'"
    :aria-hidden="!isOpen"
    data-testid="action-drawer"
  >
    <!-- Lodret skel på venstre kant (samme udtryk som venstremenuens) -->
    <div class="absolute left-0 top-0 w-px h-full bg-line/60" aria-hidden="true"></div>

    <!-- Fast-bredde indre så indholdet ikke reflower under animation -->
    <div class="w-[300px] flex flex-col h-full">
      <header class="flex items-center justify-between h-14 px-4">
        <h2 class="text-sm font-medium text-ink">{{ title }}</h2>
        <button
          type="button"
          class="flex items-center justify-center w-8 h-8 rounded-lg text-muted hover:bg-hover hover:text-ink transition-colors"
          :aria-label="`Luk ${title.toLowerCase()}`"
          @click="close"
        >
          <span class="block w-5 h-5" v-html="ICONS.close" />
        </button>
      </header>

      <div class="flex-1 overflow-y-auto scrollbar-none px-4 pb-[calc(1rem+var(--mobile-nav-h))]">
        <!-- Sidernes ActionDrawerContent teleporterer herind -->
        <div id="action-drawer-body"></div>
      </div>
    </div>
  </aside>
</template>
